<template>
  <DefaultLayout />
</template>

<script setup lang="ts">
import { attachAuthTokenInterceptor } from "@/api/httpClient";
import { useAuth } from "@/composables/useAuth";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const { fetchToken } = useAuth();

attachAuthTokenInterceptor(fetchToken);
</script>

<style scoped></style>
